import { Editor } from 'slate';
import { getNodesForSelection } from '../selection/getNodesForSelection';
import { getInsertActions } from './getInsertActions';

export function getInsertActionsForSelection(editor: Editor) {
  const elements = getNodesForSelection(editor);

  return getInsertActions(editor, elements);
}
